<template lang="html">
  <fullscreen-overlay-layout
    :pageWidth="
      tab === 'class-wide'
        ? '900px'
        : tab === 'originality'
        ? '1000px'
        : '1200px'
    "
    :centeredTitle="true"
    :loading="fetchingData"
    :title="getCurrentRT.title"
    class="tc"
    @close="$emit('close')"
  >
    <!-- Breakdown of Class Wide Engagement -->
    <div v-if="hasTeacherPermissionsInCourse">
      <pl-button
        @click.native="changeTab('class-wide')"
        :class="getBtnClass('class-wide')"
        style="color: black;"
      >
        <img
          src="/static/live_discussion/polls.svg"
          alt=""
          height="18px"
          width="22px"
        />
        <span> Class-wide </span>
      </pl-button>
      <pl-button
        @click.native="changeTab('individual')"
        :class="getBtnClass('individual')"
        style="width: 130px; color: black;"
      >
        <img src="/static/live_discussion/individual.svg" alt="" />
        <span> Individual </span>
      </pl-button>
      <!-- <pl-button @click.native="changeTab('originality')" :class="getBtnClass('originality')">
        <img
          src="/static/point_types/im_curious.svg"
          alt=""
          height="18px"
          width="22px"
        />
        <span> Originality </span>
      </pl-button> -->
    </div>
    <template v-if="canRender && desiredTabIs('class-wide')">
      <div class="pl-title row no-padding center-xs mt6">
        <!-- Flex Column for the Numbers -->
        <div class="flex-column center-xs mr4">
          <div
            class="b mb4"
            style="font-size: 30px;"
            :style="{ color: determineColourByPercentage(participation_rate) }"
          >
            {{ Math.round(participation_rate) }}%
          </div>
          <div
            class="b mb4"
            style="font-size: 30px;"
            :style="{
              color: determineColourByPercentage(
                class_summary_details.students_who_made_at_least_one_comment
              ),
            }"
          >
            {{
              Math.round(
                class_summary_details.students_who_made_at_least_one_comment
              )
            }}%
          </div>
          <div
            class="b"
            style="font-size: 30px;"
            :style="{
              color: determineColourByPercentage(
                class_summary_details.students_who_received_at_least_one_comment
              ),
            }"
          >
            {{
              Math.round(
                class_summary_details.students_who_received_at_least_one_comment
              )
            }}%
          </div>
        </div>

        <!-- Flex Column for the Explanations -->
        <div class="flex-column items-center tl">
          <div class="mb4">Submitted a response</div>
          <div class="mb4">Gave at least one comment</div>
          <div>Received at least one comment</div>
        </div>
      </div>
      <div
        v-my-tooltip.bottom="configTooltip(reflections.percentages)"
        class="reflection-text"
      >
        Reflection Questions
      </div>

      <div class="vertical-line" />

      <!-- Average Comment Length -->
      <div>
        <div
          class="b mb2 tc"
          style="font-size: 30px; position: relative;"
          :style="{ color: graph_style.background_color }"
        >
          {{ Math.round(class_summary_details.average_comment_length) }} words
          <pl-button
            @click.native="show_modal = true"
            class="pl-icon"
            style="position: absolute; top: -11px; margin-left: 10px;"
          >
            <i class="fas fa-info-circle" />
          </pl-button>
        </div>
        <div class="pl-title tc">Average Comment Length</div>
        <div class="outer-graph">
          <div class="line" style="left: 25%;">
            <div class="number">10</div>
          </div>
          <div class="line" style="right: 25%;">
            <div class="number">30</div>
          </div>
          <div
            class="inner-graph"
            :style="{
              width: graph_style.width,
              'border-radius': graph_style.border_radius,
              'background-color': graph_style.background_color,
            }"
          ></div>
        </div>
      </div>
      <div
        v-my-tooltip.bottom="configTooltip(reflections.comment_length)"
        class="reflection-text"
      >
        Reflection Questions
      </div>

      <div class="vertical-line" />

      <nlp-word-cloud />
      <div
        v-my-tooltip.bottom="configTooltip(reflections.word_cloud)"
        class="reflection-text"
      >
        Reflection Questions
      </div>
      <div class="vertical-line" />
      <model-submissions
        class="tc"
        :scrollToElement="scrollToModelSubmissions"
        @goToSubmission="goToSubmission"
      />
      <div
        v-my-tooltip.bottom="configTooltip(reflections.model_submissions)"
        class="reflection-text"
      >
        Reflection Questions
      </div>

      <div class="vertical-line" />

      <!-- should be different component for median -->

      <comment-rate
        class="tc"
        :commentMedian="median_comments"
        :commentRate="comment_per_student"
      />

      <div class="vertical-line" />

      <chord-diagram class="tc" />
      <div
        v-my-tooltip.bottom="configTooltip(reflections.comment_chord)"
        class="reflection-text mb6"
      >
        Reflection Questions
      </div>
      <!-- Modal for the expalanation of the graph -->
      <pl-dialog
        v-if="show_modal"
        @close="show_modal = false"
        class="pl-subheading italics tc"
      >
        <p>A typical sentence is about 15 words long.</p>
        <p>
          Our hope is that students provide at least two sentences <br />
          when giving feedback to their peers.
        </p>
        <pl-button @click.native="show_modal = false" class="pl-primary">
          OK
        </pl-button>
      </pl-dialog>
    </template>
    <template v-else-if="desiredTabIs('originality')">
      <br /><br />
      <plagiarism-score ref="plagSubmissions" />
    </template>
    <template v-else>
      <individual-roundtable-summary-overlay
        :table_data="table_data"
        @close="$emit('close')"
      />
    </template>
  </fullscreen-overlay-layout>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ModelSubmissions from './roundtableSummaryModelSubmissions';
  import CommentRate from './roundtableSummaryCommentRate';
  import FullscreenOverlayLayout from 'components/fullscreenOverlay';
  import WordCloud from './roundtableSummaryWordCloud';
  import ChordDiagram from './roundtableSummaryChordDiagram';

  import IndividualRoundtableSummaryOverlay from './individualRoundtableSummaryOverlay';
  import NlpWordCloud from './roundtableNlpWordCloud';
  import PlagiarismScore from './roundtableSummaryPlagiarismScore';
  // import sumBy from 'lodash/sumBy';

  import roundtableServices from 'features/onlineRoundtables/onlineRoundtables.services.js';
  import getClassSummaryDetail from '../../services/grades/classSummary';
  import reflections from './reflectionQuestions';

  export default {
    props: {
      scrollTo: {
        type: String,
        default: '',
      },
    },
    data() {
      return {
        fetchingData: false,
        ruby_colour: '#eb2d7C', // this is pl ruby
        yellow_colour: '#fecb0c',
        green_colour: '#4edb67',
        show_modal: false,
        tab: 'class-wide',
        table_data: [],
        class_summary_details: {
          students_who_made_at_least_one_comment: 100,
          students_who_received_at_least_one_comment: 100,
          average_comment_length: 20,
          average_comments_per_student: 3,
        },
        canRender: false,
      };
    },
    components: {
      FullscreenOverlayLayout,
      WordCloud,
      ChordDiagram,
      ModelSubmissions,
      IndividualRoundtableSummaryOverlay,
      CommentRate,
      NlpWordCloud,
      PlagiarismScore,
    },
    computed: {
      ...mapGetters([
        'getCurrentRT',
        'hasTeacherPermissionsInCourse',
        'getOrderedSubmissions',
      ]),
      reflections() {
        return reflections;
      },
      scrollToModelSubmissions() {
        return this.scrollTo === 'ModelSubmissions';
      },
      is_sandbox() {
        return this.getCurrentRT.is_sandbox;
      },
      graph_style() {
        const { average_comment_length } = this.class_summary_details;
        const maximum = 40; // in words
        let width;
        let border_radius = '30px 0 0 30px';
        let background_color;

        if (average_comment_length < 10) {
          background_color = this.ruby_colour;
        } else if (average_comment_length < 30) {
          background_color = this.yellow_colour;
        } else {
          background_color = this.green_colour;
        }

        if (average_comment_length / maximum >= 0.975) {
          width = '100%';
          border_radius = '30px';
        } else {
          width = `${(average_comment_length / maximum) * 100}%`;
        }

        return {
          width,
          border_radius,
          background_color,
        };
      },
      number_of_started_submissions() {
        return this.getOrderedSubmissions.filter(
          (s) => s.is_started && !s.teacher_submission
        ).length;
      },
      participation_rate() {
        const rate =
          (this.number_of_started_submissions * 100) /
          this.getOrderedSubmissions.filter((s) => !s.teacher_submission)
            .length;
        return Math.round(+rate || 0);
      },
      comment_per_student() {
        return this.class_summary_details.average_comments_per_student;
        // const total_comments = sumBy(this.getOrderedSubmissions, s => Number(s.comment_count) ) || 0;
        // const rate = (total_comments / this.number_of_started_submissions).toFixed(2);
        // return +rate || 0;
      },
      median_comments() {
        return this.class_summary_details.median_comments_submission;
      },
    },
    methods: {
      configTooltip(reflection_text) {
        return {
          content: reflection_text,
          classes: 'large-tooltip',
        };
      },
      getBtnClass(selected) {
        return selected === this.tab ? 'btn-text selected' : 'btn-text';
      },
      determineColourByPercentage(percentage) {
        if (percentage < 25) {
          return this.ruby_colour;
        } else if (percentage < 75) {
          return this.yellow_colour;
        } else {
          return this.green_colour;
        }
      },
      goToSubmission(event) {
        return this.$emit('close', event);
      },
      createTableObject(participant) {
        let result = {};
        result.name = participant.name;
        result.avatar = participant.image;
        result.anonymous_identity = participant.anonymous_identity;
        result.submissionID = participant.submission_id;
        result.submission = {
          complete: participant.submission_started ? 'yes' : 'no',
          words: participant.submission_words,
          star: participant.is_model,
        };
        result.read = Number(participant.read.replace('%', '')).toFixed(2);
        result.comments = {
          number: participant.comments_number,
          average_lenght: participant.comments_average_length,
        };
        result.feedback = {
          complete: participant.teacher_feedback !== '' ? 'yes' : 'no', // get teacher feedback for that student (need id)
          //response: '-', // get student response feedback for teacher
        };
        return result;
      },
      desiredTabIs(tab) {
        return this.tab === tab;
      },
      changeTab(tab) {
        this.tab = tab;
        if (tab === 'individual') {
          this.fetchingData = true;
          roundtableServices
            .getSummaryTableData(this.getCurrentRT.id)
            .then((res) => {
              this.fetchingData = false;
              this.table_data = res.data;
              this.table_data = this.table_data.map((participant) =>
                this.createTableObject(participant)
              );
              this.table_data.sort((a, b) => a.name.localeCompare(b.name));
            });
        }
      },
    },
    mounted() {
      this.fetchingData = true;
      getClassSummaryDetail(this.getCurrentRT.id).then((res) => {
        this.fetchingData = false;
        this.class_summary_details = res.data;
        this.canRender = true;
      });
    },
  };
</script>

<style scoped lang="stylus">
  @import '~app/global-stylus.styl'

  .reflection-text
    color: pl-primary
    font-weight: 500
    font-size: 16px
    margin-top: 25px

  .vertical-line
    width: 50%
    border-right: 0.1em solid alpha(pl-slate, 0.4)
    height: 6em
    margin: 6em auto 6em 0em

  .btn-text
    display:inline-block;
    color:black
    padding-bottom:2px;
    &.selected
      border-bottom:3px solid black;
      font-weight:bold

  graph-height = 25px
  .outer-graph
    background-color: #d8d8d8
    width: 400px
    height: graph-height
    border-radius: 30px
    margin-top: 10px
    margin-left: auto
    margin-right: auto
    position: relative
    .line
      width: 2px
      height: graph-height
      position: absolute
      background-color: #999999
      z-index: 2
      .number
        position: absolute
        top: graph-height
        left: -6px
    .inner-graph
      position: absolute
      height: graph-height
</style>



// WEBPACK FOOTER //
// roundtableSummaryOverlay.vue?4348d8df